import VueRouter from 'vue-router';
import store from '../store';

class Router extends VueRouter {
  constructor (options) {
    super(options);
    this.grantAccess();
  }

  grantAccess () {
    this.beforeEach((to, from, next) => {
      let granted = false;
      let initPath = '/init';
      let errorPath = '/error';
      let deniedPath = '/denied';
      let permissionPath = '/permission';
      let notificationPath = '/escrow';
      let treasuryWallettDeniedPath = [
        '/',
        '/home',
        '/voting',
        '/legal',
        '/marketplace',
        permissionPath
      ];
      let grantAccessPath = ['/', '/home', deniedPath, errorPath];
      let ownerAccessPath = [permissionPath];
      let escrowAccessPath = [notificationPath];

      if (to.path === initPath) {
        if (store.getters.isOwner()) granted = true;
      }

      grantAccessPath.forEach(path => {
        if (to.path === path) {
          granted = true;
          return;
        }
      });

      if (store.getters.getCurrentMember && store.getters.getInitStatusOwners) {
        granted = true;
        ownerAccessPath.forEach(path => {
          if (to.path === path) {
            if (!store.getters.isOwner()) {
              granted = false;
              return;
            }
          }
        });
      }
      if (store.getters.getCurrentMember && store.getters.getInitStatusOwners) {
        granted = true;
        escrowAccessPath.forEach(path => {
          if (to.path === path) {
            if (!store.getters.isReader) {
              granted = false;
              return;
            }
          }
        });
      }
      treasuryWallettDeniedPath.forEach(path => {
        if (to.path === path) {
          if (
            store.getters.getCompanyWallet &&
            store.getters.getWallet === store.getters.getCompanyWallet
          )
            granted = false;
          return;
        }
      });

      if (granted) {
        next();
        return;
      }

      next({
        path: deniedPath
      });
    });
  }
}

export default Router;
